import {
  GET_BOOKING_FAILED,
  GET_BOOKING_REQUESTED,
  GET_BOOKING_SUCCESS,
  GET_CUSTOMER_MATRIX_FAILED,
  GET_CUSTOMER_MATRIX_REQUESTED,
  GET_CUSTOMER_MATRIX_SUCCESS,
  GET_REVENUE_EXPORT_FAILED,
  GET_REVENUE_EXPORT_REQUESTED,
  GET_REVENUE_EXPORT_SUCCESS,
  GET_REVENUE_FAILED,
  GET_REVENUE_MATRIX_FAILED,
  GET_REVENUE_MATRIX_REQUESTED,
  GET_REVENUE_MATRIX_SUCCESS,
  GET_REVENUE_REQUESTED,
  GET_REVENUE_SUCCESS,
} from "resources/actionTypes";

const intialState = {
  userBooking: [],
  loading: false,
  error: null,
};
const intialStateRevenue = {
  userRevenue: [],
  loading: false,
  error: null,
};
const intialStateRevenueMatrix = {
  userRevenueMatrix: [],
  loading: false,
  error: null,
};
const intialStateRevenueExport = {
  userRevenueExport: [],
  loading: false,
  error: null,
};
const intialStateCustomerMatrix = {
  userCustomerMatrix: [],
  loading: false,
  error: null,
};

export function userBooking(state = intialState, action) {
  switch (action.type) {
    case GET_BOOKING_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        userBooking: action.userBooking,
      };
    case GET_BOOKING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userRevenue(state = intialStateRevenue, action) {
  switch (action.type) {
    case GET_REVENUE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_REVENUE_SUCCESS:
      return {
        ...state,
        loading: false,
        userRevenue: action.userRevenue,
      };
    case GET_REVENUE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userRevenueMatrix(state = intialStateRevenueMatrix, action) {
  switch (action.type) {
    case GET_REVENUE_MATRIX_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_REVENUE_MATRIX_SUCCESS:
      return {
        ...state,
        loading: false,
        userRevenueMatrix: action.userRevenueMatrix,
      };
    case GET_REVENUE_MATRIX_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userRevenueExport(state = intialStateRevenueExport, action) {
  switch (action.type) {
    case GET_REVENUE_EXPORT_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_REVENUE_EXPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        userRevenueExport: action.userRevenueExport,
      };
    case GET_REVENUE_EXPORT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userCustomerMatrix(state = intialStateCustomerMatrix, action) {
  switch (action.type) {
    case GET_CUSTOMER_MATRIX_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CUSTOMER_MATRIX_SUCCESS:
      return {
        ...state,
        loading: false,
        userCustomerMatrix: action.userCustomerMatrix,
      };
    case GET_CUSTOMER_MATRIX_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
